import { all } from 'redux-saga/effects';

import uploadWatcher from './uploadSaga';

export default function* rootSaga(action) {
	yield all([uploadWatcher(action)]);
}
